<h2 mat-dialog-title>
    {{ 'poll_task.make_recurrent.title' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-10 pb-0 pt-4">
    @if(task){
        <form [formGroup]="recurrenceFormGroup" class="schedule-form">
            <div class="form-group pb-4">
                <label class="form-label" for="frequency">{{'poll_creation.schedule_recurrence' | translate}}</label>
                <select formControlName="frequencyCtrl" id="frequency"
                    name="frequency" class="form-select">
                    @for(option of recurrenceOptions; track option) {
                        <option [ngValue]="option">{{ 'poll_creation.recurrence.' + option | translate}}</option>
                    }
                </select>
              </div>
            <div class="form-group pb-2 row g-3 align-items-center">
                <label class="form-label" for="displayDuration">{{ 'polls_settings.make_recurrent.desc2' | translate }}</label>
                <div class="d-flex justify-content-center align-items-center duration">
                    <input id="displayDuration" type="number" name="displayDuration" min="1" max="15"
                            class="form-control me-2"
                            formControlName="displayDurationCtrl"> 
                    <span class="text-secondary">{{'poll_creation.schedule_duration_unit' | translate}}</span> 
                </div>
                <p class="form-text text-danger error-message">
                    @if (displayDurationCtrl.invalid && (displayDurationCtrl.dirty || displayDurationCtrl.touched)) {
                        {{recurrenceErrorMessage}}
                    }
                </p>   
            </div>   
        </form>
        @if(task?.pollTargets.length > 1){
            <div class="alert alert-light">
                <p>{{ 'polls_settings.make_recurrent.scope.info' | translate }}</p>
                <div class="">
                    @for (scope of teamScopes; track scope.value)  {
                        <label for="answer-{{scope.value}}" class="border bg-grey rounded p-2 m-1 d-flex" 
                               [ngClass]="{'selected': selectedScope.value === scope.value} ">
                            <div class="check-mark-wrapper">
                                <input id="answer-{{scope.value}}" class="check-mark"
                                        type="radio" name="answer"
                                        [value]='scope'
                                        [ngModel]="selectedScope"
                                        (ngModelChange)="updateTeamScope($event)">
                            </div>
                            <div class="ps-2 pe-1">
                                <p class="role-subtitle ps-1">{{ $safeNavigationMigration(scope?.label) | translate }}</p>
                            </div>
                        </label>
                    }
                </div> 
            </div>
        }  
    }
</mat-dialog-content>

<mat-dialog-actions class="justify-content-end">
    <button type="button"
            class="btn btn-default"
            (click)="close()">{{'Cancel' | translate}}</button>
    <button type="submit"
            class="btn btn-primary" 
            [disabled]="recurrenceFormGroup.invalid"
            (click)="setRecurrence()">{{'Validate' | translate}}</button>
</mat-dialog-actions>